import Vue from "vue";
import VueRouter from "vue-router";
import VueResoure from "vue-resource";
import VueLocalStorage from "vue-localstorage";
import VueMaterial from "vue-material";
import Vuelidate from "vuelidate";
import "vue-material/dist/vue-material.css";
const moment = require("moment");
import VueScrollTo from "vue-scrollto";
import { store } from "./store/store";

import App from "./App";
import Login from "./components/Login";
import PasswordChange from "./components/PasswordChange";
import Activate from "./components/Activate";
import Portal from "./components/Portal";
import QuinyxLogInRedirect from "./components/QuinyxLogInRedirect";
import Admin from "./components/Admin";
import MyAccount from "./components/MyAccount";
import utils from "./helpers/utils";
import Auth from "./components/Auth";
import AdminUsers from "./components/AdminTabs/AdminUsers";
import AdminApps from "./components/AdminTabs/AdminApps";
import AdminAppGroups from "./components/AdminTabs/AdminAppGroups";
import AdminRoles from "./components/AdminTabs/AdminRoles";
import AdminOrganizations from "./components/AdminTabs/AdminOrganizations";
import AdminOrganizationAssignments from "./components/AdminTabs/AdminOrganizationAssignments";
import AdminUsersTeam from "./components/AdminTabs/AdminUsersTeam";
import AdminTeams from "./components/AdminTabs/AdminTeams";
import AuthorizationConfigurations from "./components/AdminTabs/AuthorizationConfigurations";
import AdminDocumentations from "./components/AdminTabs/AdminDocumentations";

Vue.use(VueMaterial);
Vue.use(VueRouter);
Vue.use(VueResoure);
Vue.use(VueLocalStorage);
Vue.use(Vuelidate);
Vue.use(VueScrollTo);

if (utils.isQuinyx()) {
  Vue.http.interceptors.push((request, next) => {
    request.withCredentials = true;
    next();
  });
}

Vue.material.registerTheme({
  default: {
    primary: "blue",
    accent: "blue",
    warn: "blue",
    background: "white",
  },
});

Vue.material.setCurrentTheme("default");

function checkAdminRole(next) {
  if (!store.state.userId) {
    store.dispatch("getValidateToken");
  }

  if (!store.state.user) {
    store
      .dispatch("getUser")
      .then(() => {
        if (store.state.isAdmin) {
          console.log("Pass");
          next();
        } else {
          console.log("Not Pass");
          next(false);
        }
      })
      .catch(() => {
        console.log("ERROR");
        next(false);
      });
  } else {
    if (store.state.isAdmin) {
      console.log("PASS");
      next();
    } else {
      console.log("Not Pass");
      next(false);
    }
  }
}

const routes = [
  { path: "/portal", name: "portal", component: Portal },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    beforeEnter: (to, from, next) => {
      checkAdminRole(next);
    },
    beforeRouteUpdate: (to, from, next) => {
      checkAdminRole(next);
    },
    children: [
      { path: "users", name: "users", component: AdminUsers },
      { path: "apps", name: "apps", component: AdminApps },
      { path: "app-groups", name: "app-groups", component: AdminAppGroups },
      { path: "roles", name: "roles", component: AdminRoles },
      {
        path: "organizations",
        name: "organizations",
        component: AdminOrganizations,
      },
      {
        path: "organizations-assignments",
        name: "organizations-assignments",
        component: AdminOrganizationAssignments,
      },
      {
        path: "team-assignments",
        name: "team-assignments",
        component: AdminUsersTeam,
      },
      { path: "teams", name: "teams", component: AdminTeams },
      {
        path: "auth-configs",
        name: "auth-configs",
        component: AuthorizationConfigurations,
      },
    ],
    redirect: { name: "users" },
  },
  { path: "/login", name: "login", component: Login },
  {
    path: "/quinyx-sign-in",
    name: "quinyx-sign-in",
    component: QuinyxLogInRedirect,
  },
  { path: "/my-account", name: "my-account", component: MyAccount },
  { path: "/externallogin", name: "externallogin", component: Login },
  {
    path: "/passwordchange",
    name: "passwordchange",
    component: PasswordChange,
  },
  { path: "/activate", name: "activate", component: Activate },
  { path: "/auth", name: "auth", component: Auth },
  { path: "*", redirect: { name: "portal" } },
];

const router = new VueRouter({ routes });

const loginRoute = window === window.top ? "/login" : "/externallogin";
const checkWhiteList = (path) => {
  const list = [
    "/login",
    "/activate",
    "/passwordchange",
    "/auth",
    "/externallogin",
  ];
  return list.indexOf(path) !== -1;
};
const setCurrentNav = (path) => {
  let currentItem = store.state.navbarItems.find((item) => item.url === path);
  if (!currentItem) {
    currentItem = store.state.forecastItems.find((item) => item.url === path);
  }
  store.commit({
    type: "SET_ACTIVE_LINK",
    currentItem,
  });
};
const routeChecks = () => {
  if (!store.state.user) store.dispatch("getUser");
  if (new URL(window.location.href).searchParams.get("access_token"))
    window.history.replaceState({}, "", "/");
};

// Router Guard
if (utils.isQuinyx()) {
  router.beforeEach((to, from, next) => {
    const isWhiteListed = checkWhiteList(to.path);
    store
      .dispatch("getValidateToken")
      .then(() => {
        routeChecks();
        if (to.path === "/login") {
          next("/portal");
        } else {
          setCurrentNav(to.path);
          next();
        }
      })
      .catch(() => {
        if (isWhiteListed) {
          next();
        } else {
          next(loginRoute);
        }
      });
  });
} else {
  router.beforeEach((to, from, next) => {
    const token = store.state.WBToken || localStorage.getItem("WBToken");
    const isWhiteListed = checkWhiteList(to.path);
    if (token) {
      store
        .dispatch("getValidateToken")
        .then(() => {
          routeChecks();
          if (to.path === "/login") {
            next("/portal");
          } else {
            setCurrentNav(to.path);
            next();
          }
        })
        .catch(() => {
          store.dispatch("logout");
          next(loginRoute);
        });
    } else {
      if (isWhiteListed) {
        next();
      } else {
        next(loginRoute);
      }
    }
  });
}

Vue.filter("dateFormat", function (value) {
  if (moment(value).isValid()) return moment(value).format("DD/MM/YYYY HH:mm");
  else return null;
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js